import { useTranslation } from 'react-i18next';

function Index({ className }) {
  const { i18n } = useTranslation()
  return (
    <img className={className} src={i18n.language === 'zh' ? `http://p0.${process.env.REACT_APP_STATIC_HOST}/t01b1f86e2a13604204.png` : `http://p0.${process.env.REACT_APP_STATIC_HOST}/t0126b4206668fb59b3.png`} alt="starworld"/>
  );
}

export default Index;
